const incompleteProfile = {
    namespaced: true,
    state: {
        isVisibleIncompleteProfileModal: false,
    },
    mutations: {
        UPDATE_IS_MODAL_VISIBLE(state, value) {
            state.isVisibleIncompleteProfileModal = value;
        },
    },
    actions: {      
        updateIsIncompleteProfileModallVisible: function({commit}, value) {
            commit('UPDATE_IS_MODAL_VISIBLE', value);
        },
    }
}

export default incompleteProfile;
